import { typographyClasses } from "@mui/material/Typography";
import { accordionClasses } from "@mui/material/Accordion";
import { accordionSummaryClasses } from "@mui/material/AccordionSummary";
// ----------------------------------------------------------------------
export function accordion(theme) {
    return {
        MuiAccordion: {
            styleOverrides: {
                root: {
                    backgroundColor: "transparent", // Default background is transparent
                    borderBottom: `1px solid ${theme.palette.divider}`, // Adds a border when not expanded
                    // borderTop: `1px solid ${theme.palette.divider}`,
                    boxShadow: "none", // No shadow when collapsed
                    "&:before": {
                        backgroundColor: "transparent",
                    },
                    [`&.${accordionClasses.expanded}`]: {
                        boxShadow: "0px 8px 16px 0px #919EAB29",
                        borderRadius: theme.shape.borderRadius * 1.5,
                        backgroundColor: theme.palette.background.paper,
                        border: "none", // Remove border when expanded
                    },
                    [`&.${accordionClasses.disabled}`]: {
                        backgroundColor: "transparent",
                    },
                },
            },
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    paddingLeft: theme.spacing(2),
                    paddingRight: theme.spacing(1),
                    borderRadius: 16,
                    backgroundColor: "transparent", // Keeps summary background transparent
                    [`&.${accordionSummaryClasses.disabled}`]: {
                        opacity: 1,
                        color: theme.palette.action.disabled,
                        [`& .${typographyClasses.root}`]: {
                            color: theme.palette.success.light,
                        },
                    },
                    [`&.${accordionSummaryClasses.expanded}`]: {
                        color: theme.palette.text.primary,
                        backgroundColor: theme.palette.background.paper, // Background changes when expanded
                        [`& .${typographyClasses.root}`]: {
                            color: theme.palette.text.primary,
                        },
                    },
                },
                expandIconWrapper: {
                    color: "inherit",
                    width: "18px",
                    height: "18px",
                },
            },
        },
    };
}
